import type { IconSvgObject } from './types';

const DockIcon: IconSvgObject = [
  ["path", { d: "M14 4.00195H10C6.22876 4.00195 4.34315 4.00195 3.17157 5.17353C2 6.3451 2 8.23072 2 12.002C2 15.7732 2 17.6588 3.17157 18.8304C4.34315 20.002 6.22876 20.002 10 20.002H14C17.7712 20.002 19.6569 20.002 20.8284 18.8304C22 17.6588 22 15.7732 22 12.002C22 8.23072 22 6.3451 20.8284 5.17353C19.6569 4.00195 17.7712 4.00195 14 4.00195Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 15.002H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default DockIcon;
